<template>
    <div>
        <div class="radio-tabs">
            <input type="radio" id="showComments" value="showComments" v-model="tabSelection" />
            <label for="showComments"><span class="ico material-icons align-middle">chat</span></label>

            <input type="radio" id="showAttachments" value="showAttachments" v-model="tabSelection" />
            <label for="showAttachments"><span class="ico material-icons align-middle">attachment</span></label>

            <input type="radio" id="showCharter" value="showCharter" v-model="tabSelection" />
            <label for="showCharter"><span class="ico material-icons align-middle">info_outline</span></label>
        </div>
        <project-charter class="tabs-content" v-if="tabSelection === 'showCharter'"/>
        <div class="padded empty-state tabs-content" v-if="tabSelection === 'showAttachments'">
            <span class="material-icons ico">attachment</span>
            <p>Attachments</p>
            <p class="muted">Coming soon</p>
        </div>
        <comments class="tabs-content" v-if="tabSelection === 'showComments'"/>
    </div>
</template>

<script>
    import ProjectCharter from "../app/ProjectCharter.vue";
    import Comments from "../messages/Comments.vue";

    export default {
        components: {
            ProjectCharter,
            Comments
        },
        data: function() {
            return{
                tabSelection: 'showComments'
            }
        },
        methods:{
        }
    }
</script>

<style>
.tabs-content{
    height: calc(100vh - 60px);
    overflow: auto;
}
</style>
